/* JungleSocks · «Avísame cuando vuelva» (DS Performance) · CMC 17102026
   Abre un popup al pulsar: (1) una talla agotada (tachada) o (2) el botón «Agotado».
   Guarda la petición como cliente de Shopify con etiquetas:
   avisame · avisame-<handle> · avisame-<handle>-<talla>  (filtrables en Clientes).
   El formulario es un {% form 'customer' %} nativo (sections/perf-back-in-stock.liquid, en el pie)
   y se envía de forma normal, como el de la preventa One Piece: así Shopify añade su token CAPTCHA.
   Al volver, la página trae ?customer_posted=true y el popup se abre con la confirmación. */
(() => {
  if (window.__perfBis) return;
  window.__perfBis = true;

  const I18N = {
    es: { kicker: 'Agotado', title: 'Te avisamos cuando vuelva', sizes: '¿Qué talla quieres?', hint: 'Puedes marcar varias', size: 'Talla', email: 'Tu email', submit: 'Avísame', sending: 'Enviando…', legal: 'Al apuntarte te suscribes a los emails de JungleSocks (reposiciones y novedades). Puedes darte de baja cuando quieras.', doneKicker: 'Apuntado', doneTitle: 'Hecho', doneSize: 'Te escribiremos a {email} en cuanto vuelva {product} en talla {sizes}.', done: 'Te escribiremos a {email} en cuanto vuelva {product}.', cont: 'Seguir mirando', errEmail: 'Revisa el email.', errSize: 'Elige al menos una talla.', errGeneric: 'No se ha podido guardar. Inténtalo de nuevo.', close: 'Cerrar', and: 'y' },
    en: { kicker: 'Sold out', title: 'We’ll let you know when it’s back', sizes: 'Which size do you want?', hint: 'You can pick more than one', size: 'Size', email: 'Your email', submit: 'Notify me', sending: 'Sending…', legal: 'By signing up you subscribe to JungleSocks emails (restocks and news). You can unsubscribe at any time.', doneKicker: 'Signed up', doneTitle: 'Done', doneSize: 'We’ll email {email} as soon as {product} is back in size {sizes}.', done: 'We’ll email {email} as soon as {product} is back.', cont: 'Keep browsing', errEmail: 'Check your email.', errSize: 'Pick at least one size.', errGeneric: 'Couldn’t save it. Please try again.', close: 'Close', and: 'and' },
    fr: { kicker: 'Épuisé', title: 'On vous prévient dès son retour', sizes: 'Quelle taille voulez-vous ?', hint: 'Vous pouvez en cocher plusieurs', size: 'Taille', email: 'Votre e-mail', submit: 'M’avertir', sending: 'Envoi…', legal: 'En vous inscrivant, vous recevrez les e-mails de JungleSocks (réassorts et nouveautés). Désinscription possible à tout moment.', doneKicker: 'Inscrit', doneTitle: 'C’est fait', doneSize: 'Nous écrirons à {email} dès que {product} sera de retour en taille {sizes}.', done: 'Nous écrirons à {email} dès que {product} sera de retour.', cont: 'Continuer', errEmail: 'Vérifiez l’e-mail.', errSize: 'Choisissez au moins une taille.', errGeneric: 'Impossible d’enregistrer. Réessayez.', close: 'Fermer', and: 'et' },
    de: { kicker: 'Ausverkauft', title: 'Wir sagen dir Bescheid, wenn er zurück ist', sizes: 'Welche Größe möchtest du?', hint: 'Mehrfachauswahl möglich', size: 'Größe', email: 'Deine E-Mail', submit: 'Benachrichtigen', sending: 'Wird gesendet…', legal: 'Mit der Anmeldung abonnierst du die E-Mails von JungleSocks (Nachschub und Neuheiten). Abmeldung jederzeit möglich.', doneKicker: 'Angemeldet', doneTitle: 'Erledigt', doneSize: 'Wir schreiben an {email}, sobald {product} in Größe {sizes} wieder da ist.', done: 'Wir schreiben an {email}, sobald {product} wieder da ist.', cont: 'Weiter stöbern', errEmail: 'Bitte E-Mail prüfen.', errSize: 'Wähle mindestens eine Größe.', errGeneric: 'Speichern fehlgeschlagen. Bitte erneut versuchen.', close: 'Schließen', and: 'und' },
    it: { kicker: 'Esaurito', title: 'Ti avvisiamo quando torna', sizes: 'Che taglia vuoi?', hint: 'Puoi sceglierne più di una', size: 'Taglia', email: 'La tua email', submit: 'Avvisami', sending: 'Invio…', legal: 'Iscrivendoti ricevi le email di JungleSocks (riassortimenti e novità). Puoi annullare l’iscrizione quando vuoi.', doneKicker: 'Iscritto', doneTitle: 'Fatto', doneSize: 'Scriveremo a {email} appena {product} torna nella taglia {sizes}.', done: 'Scriveremo a {email} appena {product} torna disponibile.', cont: 'Continua a guardare', errEmail: 'Controlla l’email.', errSize: 'Scegli almeno una taglia.', errGeneric: 'Impossibile salvare. Riprova.', close: 'Chiudi', and: 'e' },
    pt: { kicker: 'Esgotado', title: 'Avisamos-te quando voltar', sizes: 'Que tamanho queres?', hint: 'Podes escolher vários', size: 'Tamanho', email: 'O teu email', submit: 'Avisa-me', sending: 'A enviar…', legal: 'Ao inscreveres-te, subscreves os emails da JungleSocks (reposições e novidades). Podes cancelar quando quiseres.', doneKicker: 'Inscrito', doneTitle: 'Feito', doneSize: 'Vamos escrever para {email} assim que {product} voltar no tamanho {sizes}.', done: 'Vamos escrever para {email} assim que {product} voltar.', cont: 'Continuar a ver', errEmail: 'Verifica o email.', errSize: 'Escolhe pelo menos um tamanho.', errGeneric: 'Não foi possível guardar. Tenta novamente.', close: 'Fechar', and: 'e' },
  };
  const lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  const T = I18N[lang] || I18N.en;
  const fmt = (s, o) => s.replace(/\{(\w+)\}/g, (_, k) => (o[k] != null ? o[k] : ''));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const slug = (s) => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const within = (el, x, y) => { const r = el.getBoundingClientRect(); return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; };
  const isDefault = (vs) => vs.length === 1 && /default title/i.test(vs[0].title);

  /* ---------- Contexto de producto ---------- */
  function fromRadios(vr, pickedValue, pickedFieldset) {
    let vs = [];
    try { vs = JSON.parse(vr.querySelector('script[type="application/json"]').textContent); } catch (e) {}
    let selected = null;
    if (pickedValue != null) {
      const sets = [...vr.querySelectorAll('fieldset, .product-form__input')];
      const opts = sets.map((fs) => (fs === pickedFieldset ? pickedValue : (fs.querySelector('input:checked') || {}).value));
      selected = vs.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i])) || null;
    }
    return {
      handle: vr.dataset.bisHandle, title: vr.dataset.bisTitle, image: vr.dataset.bisImage,
      variants: vs.map((v) => ({ id: v.id, title: v.title, available: v.available })), selectedId: selected && selected.id,
    };
  }
  function fromCqb(c, pickedSize) {
    const vs = [...c.querySelectorAll('.cqb__size')].map((b) => ({ id: +b.dataset.variantId, title: b.dataset.size, available: !b.disabled }));
    const sel = vs.find((v) => v.title === pickedSize);
    return { handle: c.dataset.bisHandle, title: c.dataset.bisTitle, image: c.dataset.bisImage, variants: vs, selectedId: sel && sel.id };
  }

  /* ---------- Disparadores ---------- */
  // 1) Talla tachada en la ficha (variant-radios): no la selecciona, abre el popup.
  document.addEventListener('click', (e) => {
    const label = e.target.closest && e.target.closest('variant-radios label');
    if (!label) return;
    const input = document.getElementById(label.htmlFor);
    const vr = label.closest('variant-radios');
    if (!input || !input.classList.contains('disabled') || !vr || !vr.dataset.bisHandle) return;
    e.preventDefault();
    open(fromRadios(vr, input.value, input.closest('fieldset, .product-form__input')), label);
  }, true);

  // 1b) Talla agotada en la card y 2) botón «Agotado» (ficha, barra fija móvil y card).
  //     Los botones desactivados llevan pointer-events:none (CSS) y el clic llega al contenedor.
  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const x = e.clientX, y = e.clientY;

    const sizes = e.target.closest('.cqb__sizes');
    if (sizes) {
      const b = [...sizes.querySelectorAll('.cqb__size[disabled]')].find((el) => within(el, x, y));
      const c = sizes.closest('[data-cqb]');
      if (b && c && c.dataset.bisHandle) { e.preventDefault(); open(fromCqb(c, b.dataset.size), b); }
      return;
    }
    const buy = e.target.closest('.cqb__buy');
    if (buy) {
      const b = buy.querySelector('.cqb__add[disabled]');
      const c = buy.closest('[data-cqb]');
      if (b && c && c.dataset.bisHandle && within(b, x, y) && !c.querySelector('.cqb__size:not([disabled])')) { e.preventDefault(); open(fromCqb(c, null), b); }
      return;
    }
    const wrap = e.target.closest('.product-form__buttons');
    if (wrap) {
      const b = wrap.querySelector('.product-form__submit[disabled]');
      if (!b || !within(b, x, y)) return;
      const pf = wrap.closest('product-form');
      const vr = (pf && document.getElementById('variant-radios-' + pf.dataset.sectionId)) || document.querySelector('variant-radios[data-bis-handle]');
      if (!vr || !vr.dataset.bisHandle) return;
      const ctx = fromRadios(vr, null, null);
      const idInput = pf && pf.querySelector('.product-variant-id');
      const cur = idInput && ctx.variants.find((v) => String(v.id) === String(idInput.value));
      if (cur && cur.available) return; // desactivado por otro motivo (cargando, etc.)
      ctx.selectedId = cur ? cur.id : null;
      e.preventDefault();
      open(ctx, b);
    }
  });

  /* ---------- Popup (marcado en sections/perf-back-in-stock.liquid) ---------- */
  const KEY = 'pbis-pending';
  let root, lastFocus, ctx;
  const q = (s) => root.querySelector(s);

  function build() {
    if (root) return true;
    root = document.getElementById('PerfBis');
    if (!root) return false;
    root.querySelectorAll('[data-t]').forEach((el) => { el.textContent = T[el.dataset.t] || ''; });
    q('.pbis__close').setAttribute('aria-label', T.close);
    root.addEventListener('click', (e) => { if (e.target.closest('[data-pbis-close]')) close(); });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trap(e);
    });
    root.addEventListener('change', (e) => { if (e.target.matches('.pbis__size-input')) syncTags(); });
    q('.pbis__submit').addEventListener('click', onSubmitClick);
    return true;
  }

  function trap(e) {
    const f = [...root.querySelectorAll('button, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')].filter((el) => !el.closest('[hidden]') && !el.disabled);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  const checkedSizes = () => [...root.querySelectorAll('.pbis__size-input:checked')].map((i) => i.value);
  function syncTags() {
    const sizes = checkedSizes();
    const tags = ['avisame', 'avisame-' + ctx.handle].concat(sizes.map((s) => `avisame-${ctx.handle}-${slug(s)}`));
    q('[data-pbis-tags]').value = tags.join(', ');
  }
  function showErr(m) { const err = q('.pbis__error'); err.textContent = m; err.hidden = false; }

  function show() {
    root.hidden = false;
    document.documentElement.classList.add('pbis-lock');
    requestAnimationFrame(() => root.classList.add('is-open'));
  }

  function open(c, trigger, restore) {
    if (!c || !c.handle || !build()) return;
    ctx = c;
    lastFocus = trigger || document.activeElement;
    q('[data-pbis-form]').hidden = false;
    q('[data-pbis-done]').hidden = true;
    q('.pbis__error').hidden = true;

    q('[data-pbis-name]').textContent = c.title || '';
    q('[data-pbis-thumb]').innerHTML = c.image ? `<img src="${esc(c.image)}" alt="" width="72" height="72" loading="lazy">` : '';

    const soldOut = c.variants.filter((v) => !v.available);
    const noSizes = isDefault(c.variants) || !soldOut.length;
    q('[data-pbis-sizes]').hidden = noSizes;
    const sel = c.variants.find((v) => v.id === c.selectedId);
    q('[data-pbis-kicker]').textContent = sel && !noSizes ? ` · ${T.size} ${sel.title}` : '';
    const pre = restore && restore.sizes;
    q('[data-pbis-size-list]').innerHTML = noSizes ? '' : soldOut.map((v, i) => {
      const checked = pre ? pre.includes(v.title) : (sel && sel.id === v.id) || (!sel && soldOut.length === 1);
      return `<input type="checkbox" class="pbis__size-input" id="PbisSize${i}" value="${esc(v.title)}" ${checked ? 'checked' : ''}><label class="pbis__size" for="PbisSize${i}">${esc(v.title)}</label>`;
    }).join('');
    syncTags();

    const email = q('#PbisEmail');
    if (restore && restore.email) email.value = restore.email;
    if (!email.value) { try { email.value = localStorage.getItem('pbis-email') || ''; } catch (e) {} }

    show();
    setTimeout(() => email.focus({ preventScroll: true }), 60);
    if (!restore && window.dataLayer) window.dataLayer.push({ event: 'back_in_stock_open', product: c.handle });
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.classList.remove('pbis-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function joinList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ' + T.and + ' ' + a[a.length - 1]; }

  // Validación propia antes del envío nativo (si algo falla se cancela el clic y no se envía)
  function onSubmitClick(e) {
    q('.pbis__error').hidden = true;
    const email = q('#PbisEmail').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { e.preventDefault(); showErr(T.errEmail); return; }
    const sizes = checkedSizes();
    if (!q('[data-pbis-sizes]').hidden && !sizes.length) { e.preventDefault(); showErr(T.errSize); return; }
    syncTags();
    try {
      localStorage.setItem('pbis-email', email);
      sessionStorage.setItem(KEY, JSON.stringify({ ctx, email, sizes, y: window.scrollY }));
    } catch (x) {}
    // No se llama a preventDefault: el formulario se envía como uno normal de Shopify
  }

  function done(p) {
    if (!build()) return;
    q('[data-pbis-done-text]').textContent = p.sizes && p.sizes.length
      ? fmt(T.doneSize, { email: p.email, product: p.ctx.title, sizes: joinList(p.sizes) })
      : fmt(T.done, { email: p.email, product: p.ctx.title });
    q('[data-pbis-form]').hidden = true;
    q('[data-pbis-done]').hidden = false;
    show();
    setTimeout(() => q('[data-pbis-done] .pbis__ghost').focus({ preventScroll: true }), 60);
    if (window.dataLayer) window.dataLayer.push({ event: 'back_in_stock_signup', product: p.ctx.handle, sizes: (p.sizes || []).join(',') });
  }

  // Vuelta del envío: confirmación o error (solo si el envío salió de este popup)
  function afterPost() {
    let p = null;
    try { p = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (x) {}
    if (!p || !p.ctx || !build()) return;
    const state = (root.querySelector('[data-pbis-state]') || {}).dataset || {};
    // Shopify vuelve con #PbisForm: quitamos el ancla y devolvemos el scroll a donde estaba
    if (location.hash) history.replaceState(null, '', location.pathname + location.search);
    if (p.y != null) { window.scrollTo(0, p.y); window.addEventListener('load', () => window.scrollTo(0, p.y), { once: true }); }
    if (state.pbisState === 'ok' || /customer_posted=true/.test(location.search)) {
      const u = new URL(location.href);
      u.searchParams.delete('customer_posted');
      history.replaceState(null, '', u.pathname + u.search);
      done(p);
    } else if (state.pbisState === 'error') {
      open(p.ctx, null, p);
      showErr(state.pbisMsg || T.errGeneric);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterPost); else afterPost();
})();
